export default __webpack_public_path__ + "static/ms-azure_logo_horiz_c-gray_rgb-71883811fa78f762a2d1a2cf6c4c82ab.webp";